import "../scss/style.scss"
import jQuery from 'jquery';
// import "@babel/polyfill";
import initSwiper from "./swiper"
import initObserver from "./scroll"
import initMap from "./map"
import Dropdown from "./dropdown"
import Form from "./form"

(function($) {
  'use strict';
  new initSwiper();
  new initObserver();
  new initMap();
  new Dropdown();
  new Form();

  var $window  = $(window),
      $body    = $('#body'),
      $header  = $('#header');

  var windowW = $window.width(),
      windowH = $window.outerHeight(),
      headerHeight = $header.outerHeight(),
      isInit = true,
      isTouchDevice = false;

  function navControl() {
    var $menuBtn = $('.js-menuBtn');
    var $menu = $('.js-menu');
    var $menuItems = $('.js-menuItems').find('a');

    $menuBtn.on('click', function() {
      $body.toggleClass('is-menu-open');
      return false;
    });


    $menuItems.on( 'click', function(e) {
      var current = window.location.href.split('#')[0]; // without hash
      var href = $(this).attr('href').split('#')[0]; // without hash
      var hash = $(this).prop('hash');
      if (~current.indexOf(href) && hash) { // true when current page hash
        $body.removeClass('is-menu-open');
      }
    });

  }

  function changeHeight() {
    windowH = $window.outerHeight();
    var newWindowW = $window.width();

    if ( newWindowW != windowW || isInit ) {
      if ( newWindowW <= 750 ) {
        $('.js-100vh').css('height', windowH);
        $('.js-min100vh').css('min-height', windowH);
      } else {
        $('.js-100vh').css('height', '');
        $('.js-min100vh').css('min-height', '');
      }

      // zoom
      var domainMap = $('#js-domainMap');
      if ( newWindowW <= 1290 && newWindowW > 768 ) {
        var zoom = newWindowW / 1290;
        var contentH = domainMap.innerHeight();
        domainMap.css({
          transform: 'scale('+zoom+')',
        });
        domainMap.parent().css({
          height: contentH * zoom
        });
      } else {
        domainMap.css({
          transform: '',
        });
        domainMap.parent().css({
          height: ''
        });
      }
      if ( newWindowW <= 768 && windowH < 670 ) {
        var menuZoom = windowH / 670;
        $('.js-nav-menu').css('zoom', menuZoom);
      } else {
        $('.js-nav-menu').css('zoom', '');
      }
      if ( newWindowW <= 768 && windowH < 614 ) {
        var footerZoom = windowH / 614;
        $('.js-nav-footer').css('zoom', footerZoom);
      } else {
        $('.js-nav-footer').css('zoom', '');
      }

      // video source
      const topMovie = $('#js-topMovie');
      const movie = topMovie.attr('data-movie');
      const movieSp = topMovie.attr('data-movie-sp');
      if ( newWindowW <= 768 && newWindowW < windowH ) {
        topMovie.empty().append('<source src="'+ movieSp +'" type="video/mp4">')
      } else {
        topMovie.empty().append('<source src="'+ movie +'" type="video/mp4">')
      }

      windowW = $window.width();
      isInit = false;
      const vw = window.innerWidth * 0.01;
      document.documentElement.style.setProperty('--vw', `${vw}px`);
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
  }

  function toggleButton() {
    // <button class="js-toggle" data-target="" data-class="" data-type="add|remove">Toggle</button>
    $('.js-toggle').on('click', function(e) {
      var target    = $(this).data('target');
      var className = $(this).data('class');
      var type      = $(this).data('type');
      var tagName   = $(this).prop("tagName");

      if ( type == 'add') {
        $(target).addClass(className);
      }
      else if ( type == 'remove') {
        $(target).removeClass(className);
      }
      else {
        $(target).toggleClass(className);
      }

      if ( tagName == 'A' ) {
        return false;
      }
    });

    $('.js-modalOpen').on('click', function(e) {
      var target    = $(this).attr('href');
      $(target).addClass('is-open');
      $body.addClass('is-modal-open');
      return false;
    });

    $('.js-modalClose').on('click', function(e) {
      var target    = $(this).attr('href');
      $(target).removeClass('is-open');
      $body.removeClass('is-modal-open');
      return false;
    });
  }

  function detectTouchDevice() {
    if (window.ontouchstart === null) {
      $('body').addClass('is-touch');
      isTouchDevice = true;
    }
  }

  navControl();
  changeHeight();
  toggleButton();
  detectTouchDevice();

  var timer = false;
  $(window).on('resize', function() {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout( function() {
      changeHeight();
    } , 100);
  });

})(jQuery);
